







import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

export default Vue.extend({
  functional: true,
  props: {
    width: {
      type: Number,
      default: 30,
    },
    thickness: {
      type: Number,
      default: 1,
    },
    height: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: utilService.colorConst.dark_background,
    },
    theme : {
      type: String,
      default: 'light',
    },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    const style: CSSStyleOptions = {
      width: `${context.props.width}px`,
      height: `${context.props.height}px`,
      border: `${(context.props.width - context.props.thickness) / 2}px solid transparent`,
      borderTop: 'none',
      borderBottom: 'none',
      backgroundColor: context.props.theme === 'light' ? context.props.color : utilService.colorConst.light_background,
    };
    return (
      <div class={['sw-icon-tab-divider', `sw-icon-tab-divider--${context.props.theme}`]} style={style} {...context.data}></div>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
